import { queryInput } from 'API';
import { useCampaignContext } from 'context/CampaignContext';
import { useEffect, useState } from 'react';

export const useGetCCTotalQuery = (CCQuery: queryInput): readonly [queryInput | undefined] => {
  const { REACT_APP_AGENCY } = process.env;
  const { activeCampaign } = useCampaignContext();
  const [CCTotalQuery, setCCTotalQuery] = useState<queryInput>();

  useEffect(() => {
    if (CCQuery) {
      if (CCQuery) {
        delete CCQuery.query.groupFilters;
        // TOTAL CONVERSIONS QUERY
        const totalConversionsQuery = JSON.parse(JSON.stringify(CCQuery));
        totalConversionsQuery.query.detailedDimensions = totalConversionsQuery.query.detailedDimensions.filter(
          (element: any) =>
            element.column === 'filter_name' ||
            element.column === 'conversion_name' ||
            element.column === 'activity' ||
            element.column === 'floodlight_activity_name',
        );
        totalConversionsQuery.query.detailedDimensions.push({
          column: 'campaign_id',
          name: 'campaign_id',
          hidden: false,
          id: 'pero',
        });
        totalConversionsQuery.query.orderBy = totalConversionsQuery.query.detailedDimensions.map(
          (element: any) => element.id,
        );
        totalConversionsQuery.query.orderBy.push(totalConversionsQuery.query.metrics[0].id);
        if (totalConversionsQuery.query.calculatedMetrics.length > 0) {
          totalConversionsQuery.query.orderBy.push(totalConversionsQuery.query.calculatedMetrics[0].id);
        }

        setCCTotalQuery(totalConversionsQuery);
      }
    }
  }, [REACT_APP_AGENCY, activeCampaign?.ClientCountry, CCQuery]);

  return [CCTotalQuery];
};
